/**
 * Key-map for audio sprite lookup.
 * Populated by HowlerPixiLoaderMiddleware.ts.
 */
export const AudioSpriteMap: { [key: string]: string[] } = {};
